<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Finalizar Atendimento"
    >
        <Form
            :data="data"
            :plantao-id="plantaoId"
            @save="$emit('save')"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="$refs.Form.save()"
                color="outline-success"
            >
                Finalizar atendimento
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
}
</script>